import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { Helmet } from "react-helmet";  // Importing react-helmet
import App from "./App";
import theme from "./theme/theme";

const Index = () => {
  return (
    <React.StrictMode>
      {/* Helmet for dynamic head management */}
      <Helmet>
        <title>Praise Revival Church Dharmapuri</title>
        <meta
          name="description"
          content="Map location of Praise Revival Church Dharmapuri (PRC DPI)"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>

      {/* App Setup */}
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <App />
        </Router>
      </ThemeProvider>
    </React.StrictMode>
  );
};

ReactDOM.render(<Index />, document.getElementById("root"));
